function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Icon } from "@blueprintjs/core";
import classNames from "classnames";
import React from "react";
export default function SimpleStepViz(_ref) {
  var steps = _ref.steps,
      rest = _objectWithoutPropertiesLoose(_ref, ["steps"]);

  return /*#__PURE__*/React.createElement("ul", _extends({
    className: "bp3-breadcrumbs"
  }, rest), steps.map(function (_ref2, i) {
    var completed = _ref2.completed,
        active = _ref2.active,
        text = _ref2.text;
    return /*#__PURE__*/React.createElement("li", {
      key: i
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames("bp3-breadcrumb", {
        "bp3-breadcrumb-current": active
      })
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: completed ? "tick-circle" : undefined
    }), text));
  }));
}